import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Popup } from 'leaflet';
import { get } from 'lodash';

import { Consts } from '../../../consts/consts';
import { VehicleStatusEnum } from '../../../models/domain/VehicleStatusEnum';
import { Cluster } from '../../../models/map/Cluster';
import { MapConfigService } from '../config/map-config.service';

@Injectable()
export class PopupRendererService {

    /**
     * Flags indicating whether cluster popups are visible
     */
    private showPopups = false;

    /**
     * Service constructor
     */
    public constructor(
        private activeRoute: ActivatedRoute,
        private mapConfigService: MapConfigService,
        private router: Router,
    ) { }

    /**
         * Shows or hides all cluster popus
         * @param flag flag indicating whether to show ot hide cluster popus
         */
    public renderPopups(groups: any): void {

        const _Popup = Popup.extend({ options: { clusterId: undefined, isVisible: false } });
        const markers = groups.clusters;

        const visible: any = {};

        // schowanie wszystkich popu
        groups.popups.eachLayer((o: any) => {
            const clusterId = o.options.clusterId;
            visible[clusterId] = o;
        });

        const visibleKeys = Object.keys(visible).map(i => parseInt(i, 10));
        const clusterKeys: any[] = [];

        markers.eachLayer((m: any) => {
            const marker = <any>m;
            const options = marker.options;
            const clusterId = options.clusterId;
            clusterKeys.push(clusterId);

            if (options.isPopupVisible === true || options.isCurrentVehicle === true) {

                const cluster = (<any>window).CLUSTERS[clusterId];
                if (cluster) {
                    let className = 'popupCustom';
                    if (clusterId >= 0) {
                        className += ' popupCustomGroup';
                    } else {
                        className += ` popupCustomVehicle popup-vehicle${ clusterId }`;
                    }

                    if (visibleKeys.indexOf(clusterId) === -1) {
                        // get cluster
                      const popup = new _Popup();
                      popup.options.className = className;
                      popup.options.closeButton = false;
                      (popup as any).options.clusterId = clusterId;
                      (popup as any).options.isVisible = true;
                      popup.options.keepInView = false;
                      popup.options.autoPan = false;

                        popup.setLatLng(marker.getLatLng());
                        const content = this.renderHtmlForPopup(cluster);
                        popup.setContent(content);
                        popup.addTo(groups.popups);
                    } else {
                        visible[clusterId].setLatLng(marker.getLatLng());
                    }
                }

            } else {
                const popup = visible[clusterId];
                if (popup && popup.options.isOpenByEvent !== true) {
                    popup.options.isVisible = false;
                }
            }
        });

        visibleKeys.forEach(clusterId => {
            if (clusterKeys.indexOf(clusterId) === -1) {
                const popup = visible[clusterId];
                if (popup && popup.options.isOpenByEvent !== true) {
                    popup.options.isVisible = false;
                }
            }
        });

        // schowanie wszystkich popu
        groups.popups.eachLayer((o: any) => {
            const clusterId = o.options.clusterId;
            if (o.options.isVisible !== true) {
                groups.popups.removeLayer(o);
                o.remove();
            }
        });


    }


    /**
     * Generates html in cluster popup content
     * @param cluster
     */
    public renderHtmlForPopup(cluster: Cluster): string {
        let content = `<div class="cluster-popup-content ${ this.getClassPopupByStatusVehicle(get(cluster, 'properties.VehicleStatus', '')) }">`;

        cluster.points.sort((a, b) => a.properties.VehicleName.localeCompare(b.properties.VehicleName)).forEach(point => {
            // Jak klaster jednoosobowy bierz propertasy klastra a nie samochodu

            if (point.properties === undefined) {
                point.properties = cluster.properties;
            }

            const lat = point.lat.toString().replace(',', '.');
            const lng = point.lng.toString().replace(',', '.');

            const defaultContentStreet = `
                <span class="details-vehicle__street">Wczytywanie....</span>
                <span class="details-vehicle__date"></span>
            `;

            const streetColumHTMLValue = (): string => {
                const clusterPopup = document.getElementById(`cluster-popup-${ point.properties.Id }`);
                if (clusterPopup) {
                    const clusterPopupStreetValueCoords = clusterPopup.querySelector('.cluster-popup-item-details-vehicle__column-right');
                    if (clusterPopupStreetValueCoords && clusterPopupStreetValueCoords.innerHTML?.length) {
                        return clusterPopup.querySelector('.cluster-popup-item-details-vehicle__column-left')?.innerHTML as string;
                    }
                }
                return defaultContentStreet;
            };

            const selectedPopupIdRoute = this.activeRoute.snapshot.queryParams['id'];
            const isSelectedVehicle = selectedPopupIdRoute == get(cluster, 'properties.Id', '');

            const googleMapsUrl = `https://www.google.com/maps?t=k&q=${lat}+${lng}`;

            const vehicleNameHTML = `
                <span data-vehicle-id="${point.properties.Id}" class="popup-vehicle-register">${ point.properties.VehicleName || 'No-vehicle-register' }</span>
            `;

            if (isSelectedVehicle) {
                this.getSelectedVehiclePopup(selectedPopupIdRoute)?.classList.add('is-selected');
            }

            const onClickPopup = () => {
                document.getElementById(`cluster-popup-${ point.properties.Id }`)?.addEventListener('click', (ev) => {
                    const target = (ev.target as HTMLElement);
                    const ifGoogleMapsIcon = target.classList.contains('cluster-popup-google-maps-icon')
                    
                    if (ifGoogleMapsIcon) {
                        return;
                    }

                    this.mapConfigService.setCurrentVehicleId('tk-vehicle-details', point.properties.Id);
                    this.router.navigate(['panel', 'vehicle'], {queryParams: { 'mode': 'details', 'id': point.properties.Id }});
                });
            };

            setTimeout(() => {
                onClickPopup();
            }, 0);

            content += `
                <div
                    class="cluster-popup-item ${ this.getClassPopupByStatusVehicle(get(point, 'properties.VehicleStatus', '')) }"
                    data-vehicle-id="${point.properties.Id}"
                    id="cluster-popup-${ point.properties.Id }"
                >
                    <div class="cluster-popup-item-content" data-vehicle-id="${point.properties.Id}">
                        <div class="cluster-popup-vehicle-name" data-vehicle-id="${point.properties.Id}" title="${point.properties.VehicleName}">
                            ${ vehicleNameHTML }
                        </div>
                        <a class="cluster-popup-google-maps-icon" href="${googleMapsUrl}" target="_blank"></a>
                    </div>
                    ${
                        selectedPopupIdRoute == get(cluster, 'properties.Id', '')
                        ? `<div class="cluster-popup-item-details-vehicle">
                                <div class="cluster-popup-item-details-vehicle__column-left">${ streetColumHTMLValue() }</div>
                                <button id="button-copy-coords" class="cluster-popup-item-details-vehicle__column-right" data-vehicle-coords="${ lat },${ lng }">
                                    <img src="/assets/images/shared/i-copy-black.svg"> 
                                </button>
                            </div>`
                        : ''
                    }
                </div>
            `;
        });

        content += `</div>`;

        return content;
    }

    private getSelectedVehiclePopup(id: number): Element | null {
        const elements = Array.from(document.getElementsByClassName(`popup-vehicle-${id}`));
        return elements.length > 0 ? elements[0] : null;
      }
    
    getIconForStatus(status: VehicleStatusEnum) : string {
        const vehSettings = Consts.VehicleSettingsByStatusMap.get(status);
        return vehSettings ? vehSettings.statusPopupMapIconUrl : `/assets/img/none.png`;
    }

    private getClassPopupByStatusVehicle(VehicleStatus: VehicleStatusEnum): string {
        if (VehicleStatus === VehicleStatusEnum.Parked) {
            return 'is-parked';
        }
        if (VehicleStatus === VehicleStatusEnum.Moving) {
            return 'is-moving';
        }

        const ifError =     
            VehicleStatus === VehicleStatusEnum.NoGSM ||
            VehicleStatus === VehicleStatusEnum.NoGPS ||
            VehicleStatus === VehicleStatusEnum.Disconnected ||
            VehicleStatus === VehicleStatusEnum.Towed;

        if (ifError) {
            return 'is-error';
        }
        return '';
    };

}
